/**
 * Bookmaker Utility Functions
 * 
 * Utilities for converting bookmaker IDs between frontend and backend formats
 */

/**
 * Convert frontend bookmaker ID to backend API format
 * @param {string} bookmakerId - Frontend bookmaker ID (e.g., 'bg8888')
 * @returns {string} Backend API format (e.g., 'bg_8888')
 */
export function convertBookmakerIdToApiFormat(bookmakerId) {
  if (!bookmakerId || typeof bookmakerId !== 'string') {
    return bookmakerId;
  }

  // Convert bg8888 to bg_8888 (add underscore before numbers)
  if (bookmakerId === 'bg8888') {
    return 'bg_8888';
  }

  // Return as-is for other bookmakers
  return bookmakerId;
}

/**
 * Convert array of bookmaker IDs to API format
 * @param {string[]} bookmakerIds - Array of frontend bookmaker IDs
 * @returns {string[]} Array of backend API format bookmaker IDs
 */
export function convertBookmakerIdsToApiFormat(bookmakerIds) {
  if (!Array.isArray(bookmakerIds)) {
    return bookmakerIds;
  }

  return bookmakerIds.map(bm => convertBookmakerIdToApiFormat(bm));
}

/**
 * Convert comma-separated bookmaker string to API format
 * @param {string} bookmakersString - Comma-separated string of bookmaker IDs
 * @returns {string} Comma-separated string in API format
 */
export function convertBookmakersStringToApiFormat(bookmakersString) {
  if (!bookmakersString || typeof bookmakersString !== 'string') {
    return bookmakersString;
  }

  // Split by comma, convert each, and join back
  const bookmakerIds = bookmakersString.split(',').map(bm => bm.trim());
  const convertedIds = convertBookmakerIdsToApiFormat(bookmakerIds);
  return convertedIds.join(',');
}

